import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { getPasswordScore } from '../../../../utils/passwordStrength';

const STRENGTH_TIERS = {
  0: { color: 'bg-red-500', label: 'Very weak' },
  1: { color: 'bg-orange-500', label: 'Weak' },
  2: { color: 'bg-amber-500', label: 'Fair' },
  3: { color: 'bg-lime-500', label: 'Good' },
  4: { color: 'bg-emerald-500', label: 'Strong' },
};

const PasswordStrengthMeter = ({ password, strengthInputs = [] }) => {
  const score = useMemo(
    () => getPasswordScore({ password, strengthInputs }),
    [password, strengthInputs]
  );

  const hasPassword = Boolean(password);
  const tier = STRENGTH_TIERS[score];

  return (
    <div className="flex flex-col gap-1">
      <div aria-hidden="true" className="flex gap-1">
        {Object.keys(STRENGTH_TIERS).map((key) => {
          const backgroundColor =
            hasPassword && Number(key) <= score ? tier.color : 'bg-muted-foreground/20';

          return (
            <div key={key} className={cn('h-1 flex-1 rounded-full', backgroundColor)} />
          );
        })}
      </div>

      <p aria-live="polite" className="text-muted-foreground">
        Password strength: <span>{hasPassword ? tier.label : '—'}</span>
      </p>
    </div>
  );
};

PasswordStrengthMeter.propTypes = {
  password: PropTypes.string.isRequired,
  strengthInputs: PropTypes.arrayOf(PropTypes.string),
};

export default PasswordStrengthMeter;
